import classNames from 'classnames'
import PropTypes from 'prop-types'

import classes from './MembersEnrollmentsTable.module.scss'
import StudentWithAvatar from '../../students/StudentWithAvatar'

const MembersEnrollmentsTable = ({ enrollments }) => (
  <div className={classes.enrollmentsTableWrapper}>
    <header className={classNames(classes.gridLayout, classes.tableHeader)}>
      <span>Student</span>
      <span>Program</span>
      <span>Package&Amount</span>
      <span>Payment Status</span>
      <span>Status</span>
    </header>
    {enrollments.map(enrollment => (
      <div key={enrollment.id} className={classNames(classes.row, classes.gridLayout)}>
        <div className={classNames(classes.col, classes.student)}>
          <StudentWithAvatar student={enrollment.user} />
          <span className='font-weight-bold'>{enrollment.user.firstName} {enrollment.user.lastName}</span>
        </div>

        <div className={classes.col}>
          <span className='font-weight-bold'>{enrollment.course?.name}</span>
        </div>

        <div className={classes.col}>
          {enrollment.package ? (
            <span>{enrollment.package?.name} - ${enrollment.package?.price}</span>
          ) : (
            <span>-</span>
          )}
        </div>

        <div
          className={
            classNames(
              classes.col,
              classes.paymentStatus,
              {
                [classes.paid]: enrollment.paymentStatus === 'paid',
                [classes.invoiced]: enrollment.paymentStatus === 'invoiced',
              }
            )
          }
        >
          <span>{enrollment.paymentStatus ?? '-'}</span>
        </div>

        <div
          className={
            classNames(
              classes.col,
              classes.status,
              {
                [classes.completed]: enrollment.status === 'completed',
                [classes.active]: enrollment.status === 'active',
              }
            )
          }
        >
          <span>{enrollment.status ?? '-'}</span>
        </div>
      </div>
    ))}
  </div>
)

MembersEnrollmentsTable.propTypes = {
  enrollments: PropTypes.array.isRequired,
}

export default MembersEnrollmentsTable
